import { render } from "./UISettings.vue?vue&type=template&id=1935f262"
import script from "./UISettings.vue?vue&type=script&lang=js"
export * from "./UISettings.vue?vue&type=script&lang=js"

import "./UISettings.vue?vue&type=style&index=0&id=1935f262&lang=scss"
script.render = render

export default script